export const PNG_IMAGES = {
    hand: require('../../../images/hand.png'),
    summarizationWelcome: require('../../../images/promo/summarization-welcome.png'),
    blurredV2: require('../../../images/background/blurred-v2.png'),
    nativeAppBannerPhone: require('../../../images/native-app-banner/phone.png'),
    webStubDownload: require('../../../images/web-stub/download.png'),
    touchStubPhoneAndLogo: require('../../../images/touch-stub/phone-and-logo.png'),
} as const;

export type PngImageName = keyof typeof PNG_IMAGES;
